import * as Cookie from "js-cookie";

const getCSRFToken: () => string | null | undefined = () =>
  Cookie.get("csrf_token");

export default getCSRFToken;
